import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

const container = document.getElementById('clinic-search-app');

if (container) {
  // Remove the loading placeholder
  container.innerHTML = '';

  const apiBase =
    window.clinicSearchConfig?.apiBase ||
    '/wp-json/clinic-search/v1';

  const root = createRoot(container);
  root.render(<App apiBase={apiBase} />);
}
